import { BaseControl } from './BaseControl';
import constants from '@Common/Core/Constant';
import { Input } from '@Common/Controls/Input';

export class TimeSpan extends BaseControl {
    private _onChange: IHandler;
    private _days: JQuery<HTMLElement>;
    private _daysInput: Input;
    private _hours: JQuery<HTMLElement>;
    private _hoursSlider: JQuery;
    private _hoursSliderValue: JQuery<HTMLElement>;
    private _mins: JQuery<HTMLElement>;
    private _minsSlider: JQuery;
    private _minsSliderValue: JQuery<HTMLElement>;
    private _seconds: JQuery<HTMLElement>;
    private _secondsSlider: JQuery;
    private _secondsSliderValue: JQuery<HTMLElement>;

    constructor(param) {
        super(
            $.extend(
                {
                    css: null,
                    className: '',
                    width: 250,
                    height: 'auto',

                    minDays: 0,
                    maxDays: 100,

                    minHours: 0,
                    maxHours: 23,

                    minMinutes: 0,
                    maxMinutes: 59,

                    minSeconds: 0,
                    maxSeconds: 59,

                    format: constants.dayTimeSpanFormat
                },
                param
            )
        );

        this._onChange = $.noop;

        this._init();
        this._applyDefaultParam();
    }

    //milliseconds
    value(data?: number): number {
        if (data == undefined) {
            const days = parseInt(this._daysInput.getValue()) * 24 * 60 * 60 * 1000;
            const hours = parseInt(this._hoursSliderValue.text()) * 60 * 60 * 1000;
            const mins = parseInt(this._minsSliderValue.text()) * 60 * 1000;
            const seconds = parseInt(this._secondsSliderValue.text()) * 1000;

            return days + hours + mins + seconds;
            //return formatHelper.formatMilliseconds(v, this._param.format);
        } else {
            const dayTicks = 24 * 60 * 60 * 1000;
            const days = Math.floor(data / dayTicks);

            if (days >= 1) {
                data -= days * dayTicks;
            }

            const hourTicks = 60 * 60 * 1000;
            const hours = Math.floor(data / hourTicks);

            if (hours >= 1) {
                data -= hours * hourTicks;
            }

            const minutTicks = 60 * 1000;
            const minutes = Math.floor(data / minutTicks);

            if (minutes >= 1) {
                data -= minutes * minutTicks;
            }

            const secondTicks = 1000;
            const seconds = Math.floor(data / secondTicks);

            this._daysInput.setValue(days);

            this._hoursSlider.slider('value', hours);
            this._hoursSliderValue.text(hours);

            this._minsSlider.slider('value', minutes);
            this._minsSliderValue.text(minutes);

            this._secondsSlider.slider('value', seconds);
            this._secondsSliderValue.text(seconds);
        }
    }

    protected _init(): void {
        this._root = $('<table class="time-span" style="table-layout: fixed;"><thead></thead><tbody></tbody></table>');

        // days
        this._days = $('<tr><td style="width: 80px;">' + strings.timeSpan.days + '</td></tr>').appendTo(this._root);
        this._daysInput = new Input({
            width: 125
        });
        this._daysInput.setValue(this._param.minDays);
        this._daysInput.onChange(
            function () {
                this._onChange();
            }.bind(this)
        );

        $('<td/>').append(this._daysInput.getControl()).appendTo(this._days);
        $('<td style="width: 40px;"/>').appendTo(this._days);

        // hours
        this._hours = $('<tr><td>' + strings.timeSpan.hours + '</td></tr>').appendTo(this._root);
        this._hoursSlider = $('<div class="hours-slider" ></div>').slider({
            min: this._param.minHours,
            max: this._param.maxHours,
            slide: function (e, ui) {
                this._hoursSliderValue.text(ui.value);
                this._onChange();
            }.bind(this)
        });
        $('<td/>').append(this._hoursSlider).appendTo(this._hours);
        this._hoursSliderValue = $('<span class="time-span-value">' + this._param.minHours + '</span>');
        $('<td/>').append(this._hoursSliderValue).appendTo(this._hours);

        // minutes
        this._mins = $('<tr><td>' + strings.timeSpan.minutes + '</td></tr>').appendTo(this._root);
        this._minsSlider = $('<div class="minutes-slider" ></div>').slider({
            min: this._param.minMinutes,
            max: this._param.maxMinutes,
            slide: function (e, ui) {
                this._minsSliderValue.text(ui.value);
                this._onChange();
            }.bind(this)
        });
        $('<td/>').append(this._minsSlider).appendTo(this._mins);
        this._minsSliderValue = $('<span class="time-span-value">' + this._param.minMinutes + '</span>');
        $('<td/>').append(this._minsSliderValue).appendTo(this._mins);

        // seconds
        this._seconds = $('<tr><td>' + strings.timeSpan.seconds + '</td></tr>').appendTo(this._root);
        this._secondsSlider = $('<div class="seconds-slider" ></div>').slider({
            min: this._param.minSeconds,
            max: this._param.maxSeconds,
            slide: function (e, ui) {
                this._secondsSliderValue.text(ui.value);
                this._onChange();
            }.bind(this)
        });
        $('<td/>').append(this._secondsSlider).appendTo(this._seconds);
        this._secondsSliderValue = $('<span class="time-span-value">' + this._param.minSeconds + '</span>');
        $('<td/>').append(this._secondsSliderValue).appendTo(this._seconds);
    }

    public onChange(fn: IHandler): void {
        if ($.isFunction(fn)) {
            this._onChange = fn;
        }
    }
}
